module.exports = __webpack_public_path__ + "static/media/porcent.60797c0f.svg";